/** Saved-view queries shared by the rail (each token's default view) and the views list. */
import { useViews } from "@/api/hooks";
import type { View } from "@/api/types";

export function useAllViews() {
  return useViews({});
}

/** Each job's default view, by job id (the rail lists it among the token's pages). */
export function useDefaultViews(): Map<string, View> {
  const views = useAllViews();
  const byJob = new Map<string, View>();
  for (const v of views.data?.data ?? []) if (v.job && v.is_default && !byJob.has(v.job)) byJob.set(v.job, v);
  return byJob;
}
